import { createSelector } from "reselect";
import { accountTypeOptions, booleanOptions, ledgerAccountOptions } from "./accountingAccountOptions";

// value -> label maps (fuente única de verdad, compartida con el formulario)
const accountTypeLabelByValue = new Map(
  accountTypeOptions.map((opt) => [opt.value, opt.label])
);
const ledgerAccountLabelByValue = new Map(
  ledgerAccountOptions.map((opt) => [opt.value, opt.label])
);
const booleanLabelByValue = new Map(
  booleanOptions.map((opt) => [opt.value, opt.label])
);

// Base selectors
const selectAccountingAccountList = (state) =>
  state.accountingAccount?.accountingAccountList || [];
const selectSatGroupingCodesList = (state) =>
  state.accountingAccount?.satGroupingCodesList || [];

// Subcuentas agrupadas por cuenta padre: se construye una vez por cambio de
// lista para que cada fila de la tabla consulte las suyas en O(1).
const EMPTY_CHILDREN = [];

const selectChildrenByParent = createSelector(
  [selectAccountingAccountList],
  (accountingAccountList) => {
    const childrenByParent = new Map();
    accountingAccountList.forEach((acc) => {
      if (!acc.parentAccount) return;
      const children = childrenByParent.get(acc.parentAccount) || [];
      children.push(acc);
      childrenByParent.set(acc.parentAccount, children);
    });
    return childrenByParent;
  }
);

export const selectChildAccounts = (state, accountId) =>
  selectChildrenByParent(state).get(accountId) || EMPTY_CHILDREN;

// Memoized selector for table data
export const selectAccountingAccountTableData = createSelector(
  [selectAccountingAccountList, selectSatGroupingCodesList],
  (accountingAccountList, satGroupingCodesList) => {
    // Lookups O(1) en lugar de find O(n) por fila
    const parentNumberById = new Map(
      accountingAccountList.map((acc) => [acc.id, acc.number])
    );
    const satCodeById = new Map(
      satGroupingCodesList.map((code) => [code.id, code.code])
    );

    return accountingAccountList.map((account) => ({
      ...account,
      label: `${account.name} | ${account.number}`,
      accountTypeLabel: accountTypeLabelByValue.get(account.accountType) || "",
      parentAccountLabel: parentNumberById.get(account.parentAccount) || "",
      ledgerAccountLabel: ledgerAccountLabelByValue.get(account.ledgerAccount) || "",
      // El back manda la clave en `satCode`; si no viene, se cruza con el
      // catálogo SAT, y si éste no cargó se muestra el nombre (`codeName`) para
      // no dejar la columna en blanco.
      satCode:
        account.satCode ||
        satCodeById.get(account.idGrouperCodeSat) ||
        account.codeName ||
        "",
      lastLevelLabel: booleanLabelByValue.get(account.lastLevel) || "",
      affectsSpendingLabel: booleanLabelByValue.get(account.affectsSpending) || "",
    }));
  }
);
